import { WorkspaceNewService } from '@services/workspace-new.service';
import { MatDialog } from '@angular/material/dialog';
import { Constants } from '@utils/constants';
import { Inject, forwardRef } from '@angular/core';
import { AbstractItemService } from '@business/base/abstract-item.service';
import { Observable, Subject , of } from 'rxjs';
import { Box } from '@business/home/workspace-new/workspace-new.component';
import { ConfirmationModalComponent } from '@component/confirmation-modal/confirmation-modal.component';

export abstract class AbstractItem {

  dialog: MatDialog;
  data: Box;
  protected workspaceService: WorkspaceNewService;
  protected itemService: AbstractItemService;

  constructor(@Inject(forwardRef(() => WorkspaceNewService)) workspaceService: WorkspaceNewService,
    dialog: MatDialog,
    @Inject(forwardRef(() => AbstractItemService)) itemService: AbstractItemService
  ) {
    this.workspaceService = workspaceService;
    this.itemService = itemService;
    this.dialog = dialog;
    itemService.data$.subscribe(data => {
      this.data = data;
    });
  }

  removeItemFromWorkspace() {
    const confirmDialog = this.dialog.open(ConfirmationModalComponent, {
      panelClass: Constants.NORMAL_MODAL,
    });
    confirmDialog.componentInstance.content = Constants.WORKSPACE_MSG004;
    confirmDialog.afterClosed().subscribe(result => {
      if (result) {
        this.workspaceService.removeWKSItem(this.data.id, this.data.type);
      }
    });

  }

  updateOnDemand(oldSymbol: string, newSymbol: string, isExistSymbol?: boolean) {
    if (isExistSymbol) {
      this.data.symbol = oldSymbol;
    }
    if ((!oldSymbol && newSymbol) || newSymbol === '') {
      this.data.symbol = newSymbol;
      this.workspaceService.workspaceSaveOnDemand(this.data);
    } else if (oldSymbol !== null && oldSymbol !== undefined && oldSymbol.trim().toLowerCase() !== newSymbol.trim().toLowerCase()) {
      this.workspaceService.workspaceSaveOnDemand(this.data);
    }
  }

  updateContentOnDemand() {
    this.workspaceService.workspaceSaveOnDemand(this.data);
  }

  getNewWindow(nameWindow, parameters, options, id): Observable<any> {
    const subject = new Subject<any>();
    this.itemService.openNewToken(nameWindow, parameters, options, id)
      .subscribe(data => {
        subject.next(data);
      });
    return subject.asObservable();
  }

  validateOnlyOneAssetAssigned(assetName: string, type: string, idWksSelected?: number) {
    const userWorkspaces = this.workspaceService.getUserWorkspaces();
    for (let i = 0; i < userWorkspaces.length; i++) {
      if (userWorkspaces[i].Id !== undefined && userWorkspaces[i].Id === idWksSelected) {
        const workspace = JSON.parse(userWorkspaces[i].JsonData);
        for (let j = 0; j < workspace.content.length; j++) {
          if (workspace.content[j].type === type && workspace.content[j].symbol && assetName && workspace.content[j].symbol.toLowerCase() === assetName.toLowerCase()) {
            return true;
          }
        }
      }
    }
    return false;
  }

  validateMaxComponents(numberOfCompToInsert: number, idWksSelected: number) {
    const userWorkspace = this.workspaceService.getUserWorkspaceById(idWksSelected);
    if (userWorkspace && userWorkspace.JsonData) {
      const workspace = JSON.parse(userWorkspace.JsonData);
      numberOfCompToInsert += workspace.content.length;
    }
    if (numberOfCompToInsert >= Constants.NUM_MAX_WORKSPACE_CARDS) {
      return true;
    } else {
      return false;
    }
  }

}
